import React from 'react';
import { rootRoute } from '@/modules/core/root/route';
import { createRoute } from '@tanstack/react-router';

export const connectorRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'connector-redirect',
  component: React.lazy(async () => await import('@/components/ConnectorRedirect')),
  wrapInSuspense: true,
});
